module.exports = __webpack_public_path__ + "static/media/4.1a13ab8a.jpg";